import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData, unwrapPaginated } from "@/lib/api-response";
import type { PaginatedResult } from "@/types/common";
import type {
  CreateDocumentLibraryRequest,
  DocumentLibrary,
  ListDocumentLibrariesQuery,
  UpdateDocumentLibraryRequest,
} from "@/types/document";

export const documentLibraryService = {
  async list(
    query?: ListDocumentLibrariesQuery,
  ): Promise<PaginatedResult<DocumentLibrary>> {
    const params = {
      page: query?.page ?? 1,
      pageSize: query?.limit ?? 100,
      ...(query?.search ? { search: query.search } : {}),
      ...(query?.departmentId ? { departmentId: query.departmentId } : {}),
    };
    const response = await http.get(API_ENDPOINTS.DOCUMENT_LIBRARIES.LIST, {
      params,
    });
    return unwrapPaginated<DocumentLibrary>(response);
  },

  async create(
    payload: CreateDocumentLibraryRequest,
  ): Promise<DocumentLibrary> {
    const response = await http.post(
      API_ENDPOINTS.DOCUMENT_LIBRARIES.CREATE,
      payload,
    );
    return unwrapData<DocumentLibrary>(response);
  },

  async get(id: string): Promise<DocumentLibrary> {
    const response = await http.get(API_ENDPOINTS.DOCUMENT_LIBRARIES.DETAIL(id));
    return unwrapData<DocumentLibrary>(response);
  },

  async update(
    id: string,
    payload: UpdateDocumentLibraryRequest,
  ): Promise<DocumentLibrary> {
    const response = await http.patch(
      API_ENDPOINTS.DOCUMENT_LIBRARIES.DETAIL(id),
      payload,
    );
    return unwrapData<DocumentLibrary>(response);
  },

  async delete(id: string): Promise<void> {
    await http.delete(API_ENDPOINTS.DOCUMENT_LIBRARIES.DETAIL(id));
  },
};
